import { render, staticRenderFns } from "./splitItemDialog.vue?vue&type=template&id=4ff15b45&scoped=true"
import script from "./splitItemDialog.vue?vue&type=script&lang=js"
export * from "./splitItemDialog.vue?vue&type=script&lang=js"
import style0 from "./splitItemDialog.vue?vue&type=style&index=0&id=4ff15b45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff15b45",
  null
  
)

export default component.exports